import React from 'react';
import { ChevronRightIcon, StarIcon, MapPinIcon, TruckIcon, HeartIcon, ShieldCheckIcon, InfoIcon, ChevronDownIcon, PawPrintIcon } from 'lucide-react';
import { ProductCard } from '../components/shared/ProductCard';
export function ProductDetailPage() {
  const relatedProducts = [{
    name: 'Royal Canin Medium Puppy Dry Dog Food 15kg',
    price: 109.99,
    category: 'Dog Food',
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Kong Classic Dog Toy Large',
    price: 29.99,
    category: 'Dog Toys',
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Advocate Flea & Worming for Large Dogs 3 Pack',
    price: 65.99,
    category: 'Dog Health',
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }, {
    name: 'Greenies Dental Treats Regular 340g',
    price: 34.99,
    category: 'Dog Treats',
    imageColor: 'blue' as const,
    iconType: 'dog' as const
  }];
  return <main className="bg-white min-h-screen pb-20" data-id="element-698">
      {/* Breadcrumb */}
      <div className="border-b border-gray-100 py-4 bg-warm-50" data-id="element-699">
        <div className="container-wide flex items-center text-sm text-gray-500 overflow-x-auto whitespace-nowrap scrollbar-hide" data-id="element-700">
          <span className="hover:text-brand-blue cursor-pointer" data-id="element-701">Home</span>
          <ChevronRightIcon className="w-4 h-4 mx-2 flex-shrink-0" data-id="element-702" />
          <span className="hover:text-brand-blue cursor-pointer" data-id="element-703">
            Dogs & Puppies
          </span>
          <ChevronRightIcon className="w-4 h-4 mx-2 flex-shrink-0" data-id="element-704" />
          <span className="hover:text-brand-blue cursor-pointer" data-id="element-705">Dog Food</span>
          <ChevronRightIcon className="w-4 h-4 mx-2 flex-shrink-0" data-id="element-706" />
          <span className="font-medium text-gray-900 truncate" data-id="element-707">
            Royal Canin Medium Adult 15kg
          </span>
        </div>
      </div>

      <div className="container-wide pt-8 md:pt-12" data-id="element-708">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16" data-id="element-709">
          {/* Image Gallery */}
          <div className="space-y-4" data-id="element-710">
            <div className="aspect-square bg-brand-blue-50 rounded-2xl flex items-center justify-center relative border border-gray-100" data-id="element-711">
              <div className="absolute top-4 left-4" data-id="element-712">
                <span className="badge-blue text-sm px-3 py-1 shadow-sm" data-id="element-713">
                  Best Seller
                </span>
              </div>
              <PawPrintIcon className="w-32 h-32 text-brand-blue-300" data-id="element-714" />
            </div>
            <div className="grid grid-cols-4 gap-4" data-id="element-715">
              {[1, 2, 3, 4].map(i => <div key={i} className={`aspect-square rounded-xl flex items-center justify-center cursor-pointer border-2 ${i === 1 ? 'border-brand-blue bg-brand-blue-50' : 'border-transparent bg-warm-50 hover:bg-warm-100'}`} data-id="element-716">
                  <PawPrintIcon className={`w-8 h-8 ${i === 1 ? 'text-brand-blue-400' : 'text-gray-400'}`} data-id="element-717" />
                </div>)}
            </div>
          </div>

          {/* Product Info */}
          <div className="flex flex-col" data-id="element-718">
            <div className="mb-2 text-sm font-bold text-gray-500 uppercase tracking-wider" data-id="element-719">
              Royal Canin
            </div>
            <h1 className="font-heading font-extrabold text-3xl md:text-4xl text-gray-900 mb-4 leading-tight" data-id="element-720">
              Royal Canin Medium Adult Dry Dog Food 15kg
            </h1>

            <div className="flex items-center gap-4 mb-6" data-id="element-721">
              <div className="flex items-center gap-1 text-yellow-500" data-id="element-722">
                <StarIcon className="w-5 h-5 fill-current" data-id="element-723" />
                <StarIcon className="w-5 h-5 fill-current" data-id="element-724" />
                <StarIcon className="w-5 h-5 fill-current" data-id="element-725" />
                <StarIcon className="w-5 h-5 fill-current" data-id="element-726" />
                <StarIcon className="w-5 h-5 fill-current opacity-50" data-id="element-727" />
              </div>
              <span className="text-sm font-medium text-brand-blue hover:underline cursor-pointer" data-id="element-728">
                4.7 (23 reviews)
              </span>
            </div>

            <div className="mb-8 p-6 bg-warm-50 rounded-2xl border border-warm-200" data-id="element-729">
              <div className="flex items-end gap-3 mb-2" data-id="element-730">
                <span className="text-4xl font-bold text-gray-900" data-id="element-731">
                  $109.99
                </span>
              </div>

              <div className="flex items-center gap-2 mt-3 p-3 bg-brand-green-50 rounded-xl border border-brand-green-100" data-id="element-732">
                <HeartIcon className="w-5 h-5 text-brand-green fill-current" data-id="element-733" />
                <span className="font-bold text-brand-green" data-id="element-734">
                  $99.99 for Customer Care Club members
                </span>
              </div>
            </div>

            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-735">
              Complete feed for adult medium breed dogs (from 11 to 25 kg) -
              Over 12 months old. Helps support optimal digestibility thanks to
              an exclusive formula including very high quality protein and a
              balanced supply of dietary fibre.
            </p>

            {/* Action Area */}
            <div className="space-y-4 mb-8" data-id="element-736">
              <div className="flex items-center gap-4" data-id="element-737">
                <div className="w-32 flex items-center border border-gray-300 rounded-xl h-14" data-id="element-738">
                  <button className="flex-1 h-full flex items-center justify-center text-gray-500 hover:bg-gray-50 rounded-l-xl text-xl font-medium" data-id="element-739">
                    -
                  </button>
                  <span className="flex-1 text-center font-bold text-gray-900" data-id="element-740">
                    1
                  </span>
                  <button className="flex-1 h-full flex items-center justify-center text-gray-500 hover:bg-gray-50 rounded-r-xl text-xl font-medium" data-id="element-741">
                    +
                  </button>
                </div>
                <button className="flex-1 btn-primary h-14 text-lg shadow-blue-glow" data-id="element-742">
                  Check Store Availability
                </button>
              </div>
              <button className="w-full btn-secondary h-14" data-id="element-743">
                Enquire About This Product
              </button>
            </div>

            {/* Logistics Info */}
            <div className="space-y-4 bg-white border border-gray-200 rounded-2xl p-5" data-id="element-744">
              <div className="flex gap-3" data-id="element-745">
                <MapPinIcon className="w-6 h-6 text-brand-blue flex-shrink-0" data-id="element-746" />
                <div data-id="element-747">
                  <h4 className="font-bold text-gray-900" data-id="element-748">
                    Available in selected stores
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-749">
                    Contact your local store to confirm stock before visiting.
                  </p>
                </div>
              </div>
              <div className="w-full h-px bg-gray-100" data-id="element-750"></div>
              <div className="flex gap-3" data-id="element-751">
                <TruckIcon className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-752" />
                <div data-id="element-753">
                  <h4 className="font-bold text-gray-900" data-id="element-754">
                    Local Delivery Available
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-755">
                    Free local delivery on eligible orders over $100 within 5km.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Badges Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16" data-id="element-756">
          <div className="flex flex-col items-center text-center p-4 bg-warm-50 rounded-xl" data-id="element-757">
            <ShieldCheckIcon className="w-8 h-8 text-brand-blue mb-2" data-id="element-758" />
            <span className="font-bold text-sm text-gray-900" data-id="element-759">WA Owned</span>
          </div>
          <div className="flex flex-col items-center text-center p-4 bg-warm-50 rounded-xl" data-id="element-760">
            <InfoIcon className="w-8 h-8 text-brand-blue mb-2" data-id="element-761" />
            <span className="font-bold text-sm text-gray-900" data-id="element-762">
              Expert Advice
            </span>
          </div>
          <div className="flex flex-col items-center text-center p-4 bg-warm-50 rounded-xl" data-id="element-763">
            <TruckIcon className="w-8 h-8 text-brand-blue mb-2" data-id="element-764" />
            <span className="font-bold text-sm text-gray-900" data-id="element-765">
              Free Delivery Over $100
            </span>
          </div>
          <div className="flex flex-col items-center text-center p-4 bg-warm-50 rounded-xl" data-id="element-766">
            <HeartIcon className="w-8 h-8 text-brand-blue mb-2" data-id="element-767" />
            <span className="font-bold text-sm text-gray-900" data-id="element-768">
              Customer Care Club
            </span>
          </div>
        </div>

        {/* Product Details Accordion */}
        <div className="max-w-3xl mx-auto mb-20" data-id="element-769">
          <h2 className="font-heading font-extrabold text-2xl text-gray-900 mb-6" data-id="element-770">
            Product Details
          </h2>
          <div className="space-y-4" data-id="element-771">
            <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-772">
              <button className="w-full px-6 py-4 flex items-center justify-between text-left bg-white font-bold text-gray-900" data-id="element-773">
                Key Features
                <ChevronDownIcon className="w-5 h-5 text-brand-blue" data-id="element-774" />
              </button>
            </div>
            <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-775">
              <button className="w-full px-6 py-4 flex items-center justify-between text-left bg-white font-bold text-gray-900" data-id="element-776">
                Ingredients & Nutrition
                <ChevronDownIcon className="w-5 h-5 text-brand-blue" data-id="element-777" />
              </button>
            </div>
            <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-778">
              <button className="w-full px-6 py-4 flex items-center justify-between text-left bg-white font-bold text-gray-900" data-id="element-779">
                Feeding Guide
                <ChevronDownIcon className="w-5 h-5 text-brand-blue" data-id="element-780" />
              </button>
            </div>
          </div>
        </div>

        {/* Related Products */}
        <div className="mb-20" data-id="element-781">
          <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-gray-900 mb-8" data-id="element-782">
            You Might Also Like
          </h2>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-783">
            {relatedProducts.map((product, index) => <ProductCard key={index} {...product} data-id="element-784" />)}
          </div>
        </div>

        {/* Advice CTA */}
        <div className="bg-gradient-to-r from-brand-blue-50 to-brand-green-50 rounded-2xl p-8 md:p-12 text-center border border-gray-100" data-id="element-785">
          <h3 className="font-heading font-extrabold text-2xl md:text-3xl text-gray-900 mb-4" data-id="element-786">
            Need advice on choosing the right food?
          </h3>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-787">
            Our team of local experts can help you find the perfect nutrition
            for your pet's specific needs, age, and breed.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-788">
            <button className="btn-primary" data-id="element-789">Find Your Local Store</button>
            <button className="btn-secondary bg-white" data-id="element-790">
              Read Our Feeding Guides
            </button>
          </div>
        </div>
      </div>
    </main>;
}